import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "helpers/jwt-token-access/customBaseQuery";
import { InspectionReport,InspectionTypeAll } from "./type";

const convertToFormData = (obj: any) => {
  const formData = new FormData();
  Object.keys(obj).forEach((key) => {
    if (Array.isArray(obj[key])) {
      obj[key].forEach((item: any) => formData.append(key, item));
    } else {
      formData.append(key, obj[key]);
    }
  });
  return formData;
};

// Define the type for the report creation result
type CreateReportResult = {
  id: number;
  // Add other properties if needed
};

// InspectionReportSlice creation
export const inspectionReportSlice = createApi({
  reducerPath: "inspectionReportApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    // GET all inspection reports
    getInspectionReports: builder.query({
      query: (page) => `/reports/api/v1/inspection_report/?page=${page.page}&page_size=${page.pageSize}`,
    }),

    
    // POST create an inspection report
    createInspectionReport: builder.mutation({
      query: (reportData) => ({
        url: "/reports/api/v1/api/create_update_inspection/",
        method: "POST",
        body: reportData,
      }),
    }),

    // PATCH update an inspection report by ID
    updateInspectionReport: builder.mutation({
      query: ({ id, reportData }) => ({
        url: `/reports/api/v1/api/create_update_inspection/${id}/`,
        method: "PATCH",
        body: reportData,
      }),
    }),

    // GET an inspection report by ID
    getInspectionReportById: builder.query({
      query: (id) => `/reports/api/v1/inspection_report/${id}/`,
    }),

    updateInspectionReportById: builder.mutation({
      query: ({ id, reportData }: { id: any; reportData: any }) => {
        const formData = convertToFormData(reportData);
        return {
          url: `/reports/api/v1/create_update_inspection_detail/${id}/`,
          method: "PATCH",
          body: formData,
        };
      },
    }),

    postInspectionReportById: builder.mutation({
      query: (reportData) => {
        const formData = convertToFormData(reportData);
        return{
        url: "/reports/api/v1/create_update_inspection_detail/",
        method: "POST",
        body: formData,
        }
      },
    }),


    getCompanies: builder.query<any[], void>({
      query: () => "/organization/api/v1/company/",
    }),
    getTypeofInspection: builder.query<any[], void>({
      query: () => "/reports/api/v1/type_of_inspection/",
    }),
  }),
});

export const {
  useGetInspectionReportsQuery,
  useCreateInspectionReportMutation,
  useUpdateInspectionReportMutation,
  useGetInspectionReportByIdQuery,
  useUpdateInspectionReportByIdMutation,
  useGetCompaniesQuery,
  useGetTypeofInspectionQuery,
  usePostInspectionReportByIdMutation
} = inspectionReportSlice;
